import {
  DownloadJoineeAttachment,
  GetJoineeById,
  GetUpComingJoineeList,
  UpComingJoineeListProps,
  UpdateUpComingJoineeList,
} from '../../../../types/Recruitment/UpComingJoinList/UpComingJoinListTypes'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../../utils/apiUtils'
import { AllowedHttpMethods, getUpComingJoinListConfig } from '../../apiList'

const getUpComingJoinList = async (
  props: UpComingJoineeListProps,
): Promise<GetUpComingJoineeList> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: getUpComingJoinListConfig.getUpcomingJoineeList,
    method: AllowedHttpMethods.get,
    params: {
      endIndex: props.endIndex ?? '',
      searchName: props.searchName ?? '',
      startIndex: props.startIndex ?? '',
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}
const getJoineeById = async (joineeId: number): Promise<GetJoineeById> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: getUpComingJoinListConfig.getJoineeById,
    method: AllowedHttpMethods.get,
    params: {
      joineeId,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const deleteJoinee = async (joineeId: number): Promise<number | undefined> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: getUpComingJoinListConfig.deleteJoinee,
    method: AllowedHttpMethods.delete,
    params: {
      joineeId,
    },
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const UpdateNewJoinee = async (
  data: UpdateUpComingJoineeList,
): Promise<UpdateUpComingJoineeList> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: getUpComingJoinListConfig.getUpdateNewJoinee,
    method: AllowedHttpMethods.put,
    data,
  })

  const response = await useAxios(requestConfig)
  return response.data
}
const downloadJoineeCV = async (
  prepareObject: DownloadJoineeAttachment,
): Promise<Blob | undefined> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: getUpComingJoinListConfig.downloadJoineeFile,
    method: AllowedHttpMethods.get,
    params: {
      fileName: prepareObject.fileName,
      token: prepareObject.token,
      tenantKey: prepareObject.tenantKey,
    },
    responseType: 'blob',
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const exportUpcomingJoineeList = async (
  searchName?: string,
): Promise<Blob | undefined> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: getUpComingJoinListConfig.exportUpcomingJoineeList as string,
    method: AllowedHttpMethods.get,
    params: { searchName: searchName ?? '' },
    responseType: 'blob',
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const UpComingJoinListApi = {
  getUpComingJoinList,
  getJoineeById,
  deleteJoinee,
  UpdateNewJoinee,
  downloadJoineeCV,
  exportUpcomingJoineeList,
}

export default UpComingJoinListApi
